var projectSettings = {
	inlineSVG: [
		'.seed .off-canvas-contact__footer img',
		'.theme-group .header__logo img',
		'.theme-group .footer__social img',
		'.theme-group .footer__newsletter-form--submit img',
		'.footer__social img',
		'.header__login-button img'
	]
};